import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ChartsModule ,ThemeService} from 'ng2-charts';
import { HttpClientModule } from "@angular/common/http";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShareModule } from './Modules/share/share.module';
import { FooterComponent } from './Common/Components/footer/footer.component';
import { HeaderComponent } from './Common/Components/header/header.component';
import { LayoutComponent } from './Common/Components/layout/layout.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularMaterialModule } from './Common/angular-material/angular-material.module';
import { LayoutModule } from '@angular/cdk/layout';
import { TranslateService } from './Services/translate.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AboutUsComponent } from './Common/Components/about-us/about-us.component';
import { ContactUsComponent } from './Common/Components/contact-us/contact-us.component';
import { FaqComponent } from './Common/Components/faq/faq.component';
import { ErrorPopupComponent } from './Common/Notifications/error-popup/error-popup.component';
import { DashboardNavComponent } from './Common/Components/dashboard-nav/dashboard-nav.component';
import { HomeNavComponent } from './Common/Components/home-nav/home-nav.component';
import { Header2Component } from './Common/Components/header2/header2.component';
import { HomeComponent } from './Common/Components/home/home.component';
import { UserlayoutComponent } from './Common/Components/userlayout/userlayout.component';
import { LoginComponent } from './Common/Components/login/login.component';
import { ToastrModule } from 'ngx-toastr';
import { LobListPopComponent } from './Common/Components/lob-list-pop/lob-list-pop.component';
import { DateAdapter } from '@angular/material';
import { GlobalService } from 'src/app/global.service';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialogModule, MAT_DATE_LOCALE } from '@angular/material';
import { Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
//import { GetQuoteComponent } from './Modules/generalaccident/Modules/quote/Components/get-quote/get-quote.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { InterceptorService } from './Services/interceptor.service';
//import { AdminLayoutComponent } from './Common/Components/adminComponents/admin-layout/admin-layout.component';
//import { AdminDashboardComponent } from './Common/Components/adminComponents/admin-dashboard/admin-dashboard.component';
import { UsercreationComponent } from './Common/Components/adminComponents/usercreation/usercreation.component';
import { UploaddocumentComponent } from './Common/Components/adminComponents/uploaddocument/uploaddocument.component';
import { ChangePasswordComponent } from './Common/Components/change-password/change-password.component';
//import { UsercreationeditComponent } from './Common/Components/adminComponents/usercreationedit/usercreationedit.component';
//import { AdminHeaderComponent } from './Common/Components/adminComponents/admin-header/admin-header.component';
//import { AdminHeaderNavComponent } from './Common/Components/adminComponents/admin-header-nav/admin-header-nav.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminLayoutComponent } from './Common/Components/adminComponents/admin-layout/admin-layout.component';
import { AdminDashboardComponent } from './Common/Components/adminComponents/admin-dashboard/admin-dashboard.component';
import { UsercreationeditComponent } from './Common/Components/adminComponents/usercreationedit/usercreationedit.component';
import { AdminHeaderNavComponent } from './Common/Components/adminComponents/admin-header-nav/admin-header-nav.component';
import { AdminHeaderComponent } from './Common/Components/adminComponents/admin-header/admin-header.component';
import { UserCreateListingComponent } from './Common/Components/adminComponents/user-create-listing/user-create-listing.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { PromotionAdsComponent } from './Common/Components/adminComponents/promotion-ads/promotion-ads.component';
import { LobListCsrComponent } from './Common/Components/lob-list-csr/lob-list-csr.component';
import { AdminContactUsComponent } from './Common/Components/adminComponents/admin-contact-us/admin-contact-us.component';
import { PushNotificationComponent } from './Common/Components/adminComponents/push-notification/push-notification.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

//import { GetQuoteComponent } from './get-quote/get-quote.component';

////////////////////// For Medical purpose /////////////
import { LobDialogComponent } from './Common/Components/lob-dialog/lob-dialog.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { UserProfileComponent } from './Common/Components/user-profile/user-profile.component'; // import bn-ng-idle service
import { CategoryDialogComponent } from './Modules/medical/modules/broker/modules/buy-policy/components/category-dialog/category-dialog.component';
import { MotorPageComponent } from './Common/Components/motor-page/motor-page.component';
import { TravelPageComponent } from './Common/Components/travel-page/travel-page.component';
import { FaqHealthInsuranceComponent } from './Common/Components/faq-health-insurance/faq-health-insurance.component';
import { FaqTravelInsuranceComponent } from './Common/Components/faq-travel-insurance/faq-travel-insurance.component';
import { FaqMotorInsuranceComponent } from './Common/Components/faq-motor-insurance/faq-motor-insurance.component';
import { FaqFireInsuranceComponent } from './Common/Components/faq-fire-insurance/faq-fire-insurance.component';
import { HealthPageComponent } from './Common/Components/health-page/health-page.component';
import { HealthsenseAllComponent } from './Common/Components/healthsense-all/healthsense-all.component';
import { HealthsenseExecutiveComponent } from './Common/Components/healthsense-executive/healthsense-executive.component';
import { HealthsensePlatinumComponent } from './Common/Components/healthsense-platinum/healthsense-platinum.component';
import { UpdateProfileComponent } from './Common/Components/update-profile/update-profile.component';
import { TimerConfirmComponent } from './Common/Components/timer-confirm/timer-confirm.component';
import { PinGeneratonComponent } from './Common/Components/adminComponents/pin-generaton/pin-generaton.component'; // import bn-ng-idle service
import { LanguageSetupComponent } from './Common/Components/adminComponents/language-setup/language-setup.component';
import { SessionTimingComponent } from './Common/Components/adminComponents/session-timing/session-timing.component';
import { DashboardMenuComponent } from './Common/Components/adminComponents/dashboard-menu/dashboard-menu.component';
import { FirePageComponent } from './Common/Components/fire-page/fire-page.component';
import { GeneralAccidentComponent } from './Common/Components/general-accident/general-accident.component';
import { AdminImageUploadComponent } from './Common/Components/adminComponents/admin-image-upload/admin-image-upload.component';
import { CsrCategoryDialogComponent } from 'src/app/Modules/medical/modules/medical-csr/components/medical-csr-buy-policy/csr-category-dialog/csr-category-dialog.component';
import { LobPopupComponent } from './Common/Components/lob-popup/lob-popup.component';
import { AdminchangePasswordComponent } from './Common/Components/adminComponents/adminchange-password/adminchange-password.component';
//import { CountdownModule } from 'ngx-countdown';
import { CommonMessageComponent } from './Common/Components/common-message/common-message.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxCurrencyModule } from "ngx-currency";
import { UnderconstructionComponent } from './Common/Components/underconstruction/underconstruction.component';

export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('en');
}

@NgModule({
  declarations: [
      AppComponent,
    FooterComponent,
    HeaderComponent,
    LayoutComponent,
    AboutUsComponent,
    ContactUsComponent,
    FaqComponent,
    ErrorPopupComponent,
    HomeNavComponent,
    DashboardNavComponent,
    Header2Component,
    HomeComponent,
    UserlayoutComponent,
    LoginComponent,
    LobListPopComponent,
    // ClaimNewComponent,
    AdminLayoutComponent,
    AdminDashboardComponent,
    UsercreationComponent,
    UploaddocumentComponent,
    ChangePasswordComponent,
    UsercreationeditComponent,
    AdminHeaderComponent,
    AdminHeaderNavComponent,
    UserCreateListingComponent,
    PromotionAdsComponent,
    LobListCsrComponent,
    CategoryDialogComponent,
    AdminContactUsComponent,
    PushNotificationComponent,
    UpdateProfileComponent,
    PinGeneratonComponent,
    LanguageSetupComponent,
    CsrCategoryDialogComponent,
    //GetQuoteComponent

    // Medical 
    LobDialogComponent,
    UserProfileComponent,
    MotorPageComponent,
    TravelPageComponent,
    FaqHealthInsuranceComponent,
    FaqTravelInsuranceComponent,
    FaqMotorInsuranceComponent,
    FaqFireInsuranceComponent,
    HealthPageComponent,
    HealthsenseAllComponent,
    HealthsenseExecutiveComponent,
    HealthsensePlatinumComponent,
    TimerConfirmComponent,
    SessionTimingComponent,
    DashboardMenuComponent,
    FirePageComponent,
    GeneralAccidentComponent,
    AdminImageUploadComponent,
    LobPopupComponent,
    AdminchangePasswordComponent,
    CommonMessageComponent,
    UnderconstructionComponent

  ],
  entryComponents: [
    LoginComponent,
    LobListPopComponent,
    LobListCsrComponent,
    ChangePasswordComponent,
    UsercreationeditComponent,
    UserCreateListingComponent,
    AdminchangePasswordComponent,
    CommonMessageComponent,
    UnderconstructionComponent,

    //PromotionAdsComponent
    CategoryDialogComponent,
    TimerConfirmComponent,

    // Medical
    LobDialogComponent,
    UserProfileComponent,
    UpdateProfileComponent,
    CsrCategoryDialogComponent,
    LobPopupComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    NgxCurrencyModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    FormsModule,
    ShareModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    ChartsModule,
    MatFormFieldModule,
    Ng2SmartTableModule,
    NgxSpinnerModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    OwlDateTimeModule,
     OwlNativeDateTimeModule,
    //CountdownModule,
    // MedicalModule,
    //MatDialogModule,
    ToastrModule.forRoot({
      timeOut: 6000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    
    MatPasswordStrengthModule.forRoot(),
    MatPasswordStrengthModule
  ],
  providers: [
    TranslateService,
    BnNgIdleService,
    ThemeService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },


    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MatSnackBar, useValue: {} }
    // ,
    // { provide: MAT_DATE_LOCALE, useValue: 'vi-VN' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {


  // constructor(private dateAdapter: DateAdapter<Date>,public _global: GlobalService, ){
 
    
  //   if(this._global.selectLang == "vn"){
  //     this.dateAdapter.setLocale("vi-VN"); 
  //   }
  //   else{
  //     this.dateAdapter.setLocale("en-GB");
  //   }
  // }



 }
